export default __webpack_public_path__ + "static/media/icon-business-model-freemium.ecf0b6ac.svg";